import { TranslationService } from '@/app/services/translation.service';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-404',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './404.component.html',
})
export class Page404Component {
  private router = inject(Router);
  private translationService = inject(TranslationService);

  urlImg = environment.urlIMG;

  ngOnInit(): void {
    const navType = performance.getEntriesByType(
      'navigation'
    )[0] as PerformanceNavigationTiming;

    if (navType?.type === 'reload') {
      this.router.navigateByUrl(this.translationService.getInitPathFootball());
    }
  }
  handleBackHome() {
    this.router.navigateByUrl(this.translationService.getInitPathFootball());
  }
}
